import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import * as toastr from 'toastr';

import { Section } from './models/Section';
import { AuthorizationService } from './services/authorization.service';
// import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [],
})
export class AppComponent implements OnInit {
  title = environment.applicationDisplayName;
  public currentYear = new Date().getFullYear();
  sections: Section[] = [
    {
      name: 'CONTRACTS',
      path: 'cm',
      feature: 'ContractManagement::ViewContract',
      url: '/contracts',
      isLegacyLink: false,
      subSection: null,
    },
    {
      name: 'ANALYTICS',
      path: 'looker/',
      feature: environment.applicationApplinkFeature,
      url: '/analytics',
      isLegacyLink: false,
      subSection: null,
    },
  ];

  apiRoot: string;
  constructor(private authorizationService: AuthorizationService) {
    this.setToasterOptions();
  }

  setToasterOptions(): void {
    toastr.options.showDuration = 1000;
    toastr.options.hideDuration = 1000;
    toastr.options.timeOut = 3000;
    toastr.options.extendedTimeOut = 2000;
    toastr.options.showEasing = 'swing';
    toastr.options.hideEasing = 'linear';
    toastr.options.showMethod = 'fadeIn';
    toastr.options.hideMethod = 'fadeOut';
  }

  ngOnInit(): void {
    this.apiRoot = environment.cmApiRoot.url;
  }

  routeChanged(): void {
    if (this.authorizationService.HealthcareTopBar) {
      this.authorizationService.HealthcareTopBar.notifyActivity();
    }
  }
}
